import React, { useEffect, useRef } from "react";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import "../layout/Main.scss";
import socketFunc from "../utils/socket";
import useUserDetailsRefresh from "../hook/useUserDetailsRefresh";
import { WorkClockProvider } from "../context/WorkClockContext";
import { isAdminUser } from "../utils/roles";

import { Outlet } from "react-router-dom";
import moment from "moment-timezone";
var num = 0;
var connect = false;
const Main = () => {
  const role = localStorage.getItem('UserRole')
  const { refreshUserDetails } = useUserDetailsRefresh();
  const userBootstrapRef = useRef(false);
  useEffect(() => {

    setTimeout(() => {
      const tokenc = localStorage.getItem('token')
      if (connect === false && tokenc !== null) {
        socketFunc();
        connect = true;
      }
    }, 3000);



    //  return () => {
    //     socket.disconnect();
    //     setConnected(false);
    //     connect = false;
    //     num = 0;
    //  }

  }, []);

  useEffect(() => {
    if (userBootstrapRef.current) {
      return;
    }
    userBootstrapRef.current = true;
    refreshUserDetails();
  }, [refreshUserDetails]);
  let fullYear = moment().format('Y');
  const adminUser = isAdminUser(role);

  const layout = (
    <div className="main_block">
      <div className="sidebar_section">
        <Sidebar />
      </div>
      <div className="main_section">
        <Header />
        <div className={`dashboard_main_content-${Number(role) === 1 ? 'min' : 'max'}-padding`}>
          <Outlet />
        </div>
        <footer className="app-footer">
          <div className="footer">
            <p className="footer-copyright">
              © {fullYear} LocShark, LLC. All rights reserved.
            </p>
            {!adminUser && (
              <nav className="footer-links" aria-label="Footer">
                <a href="/main/account">Account</a>
                <a href="/main/account#plans">Plans</a>
              </nav>
            )}
          </div>
        </footer>
      </div>
    </div>
  );

  return <WorkClockProvider enabled={!adminUser}>{layout}</WorkClockProvider>;
};

export default Main;
